<template>
  <transition
    name="fade"
    mode="out-in"
    :duration="{ enter: 350, leave: 150 }"
  >
    <video
      v-if="!isGifsBlocked"
      :class="$style.wrapper"
      controls
      loop
      :poster="poster"
      @play="$emit('play')"
      @ended="$emit('ended')"
    >
      <slot />
    </video>
    <div
      v-else
      :class="$style.imageWrapper"
    >
      <b-img
        :class="$style.wrapper"
        :src="poster"
        fluid
      />
      <div :class="$style.buttonWrapper">
        <font-awesome-icon
          size="3x"
          icon="unlock-alt"
        />
        <span class="py-3">{{ $t('gif-login-required-message') }}</span>
        <div class="d-flex">
          <router-link
            :to="{name: 'login'}"
            class="mr-1"
          >
            <BaseButton
              is-rounded
              size="sm"
              font-size="small"
            >
              <span class="px-2">{{ $t('login') }}</span>
            </BaseButton>
          </router-link>
          <router-link
            :to="{name: 'register'}"
            class="ml-1"
          >
            <BaseButton
              is-rounded
              size="sm"
              font-size="small"
            >
              <span class="px-2">{{ $t('register') }}</span>
            </BaseButton>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseButton from '@/components/Atoms/BaseButton'
export default {
  name: 'BaseVideo',
  components: { BaseButton },
  props: {
    poster: {
      type: String,
      required: true,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      isGifsBlocked: 'matches/matchGifs/isGifsBlocked',
    }),
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .wrapper {
    width: 100%;
  }
  .imageWrapper {
    position: relative;
    .buttonWrapper {
      background: transparentize($color-carbon, .75);
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: $color-white;
    }
  }
</style>
